/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateRegisterNumberingDto
 */
export interface CreateUpdateRegisterNumberingDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateRegisterNumberingDto
     */
    symbolDoctor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateRegisterNumberingDto
     */
    symbolPsychological?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateRegisterNumberingDto
     */
    activeFrom?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateRegisterNumberingDto
     */
    activeTo?: Date | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateRegisterNumberingDto
     */
    registerIds?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateRegisterNumberingDto
     */
    healthcareFacilityId?: string | null;
}

/**
 * Check if a given object implements the CreateUpdateRegisterNumberingDto interface.
 */
export function instanceOfCreateUpdateRegisterNumberingDto(value: object): value is CreateUpdateRegisterNumberingDto {
    return true;
}

export function CreateUpdateRegisterNumberingDtoFromJSON(json: any): CreateUpdateRegisterNumberingDto {
    return CreateUpdateRegisterNumberingDtoFromJSONTyped(json, false);
}

export function CreateUpdateRegisterNumberingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateRegisterNumberingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'symbolDoctor': json['symbolDoctor'] == null ? undefined : json['symbolDoctor'],
        'symbolPsychological': json['symbolPsychological'] == null ? undefined : json['symbolPsychological'],
        'activeFrom': json['activeFrom'] == null ? undefined : (new Date(json['activeFrom'])),
        'activeTo': json['activeTo'] == null ? undefined : (new Date(json['activeTo'])),
        'registerIds': json['registerIds'] == null ? undefined : json['registerIds'],
        'healthcareFacilityId': json['healthcareFacilityId'] == null ? undefined : json['healthcareFacilityId'],
    };
}

export function CreateUpdateRegisterNumberingDtoToJSON(value?: CreateUpdateRegisterNumberingDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'symbolDoctor': value['symbolDoctor'],
        'symbolPsychological': value['symbolPsychological'],
        'activeFrom': value['activeFrom'] == null ? undefined : ((value['activeFrom'] as any).toISOString()),
        'activeTo': value['activeTo'] == null ? undefined : ((value['activeTo'] as any).toISOString()),
        'registerIds': value['registerIds'],
        'healthcareFacilityId': value['healthcareFacilityId'],
    };
}

